import { useToast } from '@chakra-ui/react';
import axios from 'axios';
import FileSaver from 'file-saver';
import React, { useState } from 'react';

import { useGetAssetVerificationDocumentSignedUrllLazyQueryGQLType } from '../../requests/requests.gql.generated';
import { DownloadIconButton } from 'packages/common-frontend/components/IconButton';
import {
  errorToastConfig,
  errorToastId,
} from 'packages/common-frontend/constants';

export const DownloadButton: React.FC<{
  artifactDocumentId: string;
  creditFacilityId: string;
  receivableDocumentationRawId?: string;
}> = ({
  artifactDocumentId,
  creditFacilityId,
  receivableDocumentationRawId,
}) => {
  const toast = useToast();
  const [loading, setLoading] = useState<boolean>(false);
  const [
    getAssetVerificationDocumentationPresignedUrl,
  ] = useGetAssetVerificationDocumentSignedUrllLazyQueryGQLType({
    fetchPolicy: 'no-cache',
    onCompleted: (data) => {
      if (data && data.assetVerificationDocumentSignedUrl) {
        const { assetVerificationDocumentSignedUrl } = data;
        const { url, filename } = assetVerificationDocumentSignedUrl;
        axios({
          url,
          method: 'GET',
          responseType: 'blob',
        })
          .then((response) => {
            const fileBlob = new Blob([response.data], {
              type: response.data.type,
            });
            FileSaver.saveAs(fileBlob, filename);
            setLoading(false);
          })
          .catch((err) => {
            if (!toast.isActive(errorToastId)) {
              errorToastConfig.title = `Error downloading report for [filename:${filename}]`;
              toast(errorToastConfig);
            }
            throw err;
          });
      }
    },
  });

  return receivableDocumentationRawId ? (
    <DownloadIconButton
      ariaLabel="Download receivable verification documentation"
      label="Download"
      isLoading={loading}
      onClick={() => {
        getAssetVerificationDocumentationPresignedUrl({
          variables: {
            artifactDocumentId,
            creditFacilityId,
            receivableDocumentationRawId,
          },
        });
      }}
      colorScheme="blue"
    />
  ) : (
    <DownloadIconButton
      isDisabled
      ariaLabel="Download receivable verification documentation"
      label="Download"
    />
  );
};
